'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { InternalProvider, attachSubComponents, useCombinedRefs, useMediaQuery, getChildByType } from '../../../util';
import { Size } from '../../../abstracts';
import { BaseMapTemplate, PageTitleContainer, MainPanelContainer, MapContainer, Map } from './elements';
import { StyledProgressStepper as ProgressStepper } from '../elements';
import { ProgressStepperContainer } from '../TemplateProgressStepperContainer';
import { TemplateButtonGroup as ButtonGroup } from '../TemplateButtonGroup';
import { Heading } from '../Heading';
import { Subheading } from '../Subheading';
import { TemplateContext } from '../TemplateContext';
export const MapTemplate = attachSubComponents('MapTemplate', /*#__PURE__*/forwardRef(({
  children,
  ref,
  progressStepper,
  ...props
}, fRef) => {
  const combinedRef = useCombinedRefs(ref, fRef);
  const TemplateButtonGroup = getChildByType(children, ButtonGroup);
  const isMobile = useMediaQuery(`(max-width: ${Size.MD - 1}px)`);
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(TemplateContext.Provider, {
    value: {
      progressStepper: progressStepper
    }
  }, /*#__PURE__*/React.createElement(BaseMapTemplate, _extends({
    hasButtonGroup: !!TemplateButtonGroup,
    ref: combinedRef,
    progressStepper: progressStepper
  }, props), children, isMobile && progressStepper)));
}), {
  ProgressStepper,
  ProgressStepperContainer,
  ButtonGroup,
  MapContainer,
  Map,
  PageTitleContainer,
  MainPanelContainer,
  Heading,
  Subheading
});